export default __webpack_public_path__ + "static/media/SkillGrowth-Black.bd5e1126.svg";